export enum PartType {
  Same = 'Same',
  Added = 'Added',
  Removed = 'Removed',
  LineBreak = 'LineBreak',
}
